import { useMediaQuery } from "react-responsive";

export function useMobileView() {
    return useMediaQuery({ maxWidth: 1200 });
}

export function useMobileBlockScreen() {
    return useMediaQuery({ maxWidth: 800 });
}
